<script lang="ts">
	import { createEventDispatcher, onDestroy } from 'svelte';
	import { format } from 'src/services/i18n';

	import { capFirstChar } from 'src/helpers/utilities';

	import { Input, Button, Text, Icon, Alert } from '@Shelly/shelly-design-system';
	import { req_password } from 'src/services/http';
	import { validate_email } from 'src/helpers/validators';

	const dispatch = createEventDispatcher();

	const clearErrors = () => {
		if (emailError) {
			emailError = false;
		}
		if (showAlert) {
			showAlert = false;
			alertProps = {
				heading: '',
				message: '',
			};
		}
	};

	onDestroy(() => {
		clearErrors();
	});

	let email = '';
	let emailError: boolean | string = false;
	let isLoading = false;
	let showAlert = false;
	let alertProps = {
		heading: '',
		message: '',
	};

	const validateEmailInput = () => {
		const isValidState = {
			email: true,
		};
		if (email === '') {
			emailError = $format('label_enter_email', {
				default: 'Please enter an email!',
			});
			isValidState.email = false;
		} else if (!validate_email(email)) {
			emailError = $format('input_error_valid_email', {
				default: 'Please enter a valid email!',
			});
			isValidState.email = false;
		}
		return isValidState.email;
	};

	const handlePasswordReset = async (email) => {
		if (validateEmailInput()) {
			isLoading = true;

			await req_password(email).then((res) => {
				isLoading = false;

				if (res && !res.error) {
					passRequestSuccess = true;
				} else {
					if (res.error === 'not_existing') {
						alertProps.heading = $format('error_wrong_email', {
							default: `Error, ${res.error}`,
						});
						alertProps.message = $format('no_account_err_toast', {
							default: 'There is no account with this email.',
						});
					} else if (res.error === 'mail_sent') {
						alertProps.heading = $format('alert_mail_sent', {
							default: `Error, ${res.error}`,
						});
						alertProps.message = $format('alert_error_mail_sent', {
							default: 'Mail already sent in last hour.',
						});
					}
					passRequestSuccess = false;
					showAlert = true;
				}
			});
		}
	};

	let passRequestSuccess = false;
</script>

{#if passRequestSuccess}
	<div class="d-flex justify-content-center mb-m">
		<Icon icon="fa-light fa-thumbs-up text-success" size="l" />
	</div>
{/if}

<Text element="h1" class="mb-xl text-center" />

<Text class="mb-xl text-center">
	{passRequestSuccess
		? $format('text_forgotten_pass_check_email', {
				default: 'Please check your email.',
			})
		: $format('text_forgotten_pass_enter_email', {
				default: 'Enter the email you used for your account.',
			})}
</Text>

{#if showAlert}
	<Alert type="danger" heading={alertProps.heading} message={alertProps.message} class="mb-m" />
{/if}

{#if !passRequestSuccess}
	<Input
		bind:value={email}
		size="l"
		class="mb-m"
		id="input-email-forgot-password"
		label={capFirstChar($format('placeholder_email', { default: 'e-mail' }))}
		aria-label={$format('input_email_address', {
			default: 'Email address',
		})}
		icon="fa-solid fa-envelope"
		type="text"
		inputmode={'email'}
		error={emailError ? `${emailError}` : ''}
		on:click={() => clearErrors()}
		on:enter={() => handlePasswordReset(email)}
		disabled={isLoading}
	/>
	<Button
		class="mb-m"
		width="full"
		loading={isLoading}
		disabled={isLoading}
		on:click={() => handlePasswordReset(email)}
	>
		{$format('button_request_new_pass')}
	</Button>
{:else}{/if}

<Text
	element="div"
	class={`d-flex link-styles justify-content-center text-small${isLoading ? ' disabled' : ''}`}
	on:click={() => {
		if (!isLoading) {
			dispatch('close');
		}
	}}
>
	{capFirstChar($format('link_back_to_login', { default: 'back to login' }))}
</Text>
